import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router";
import { Modal } from "react-bootstrap";

import * as AppActions from "../../reducers/appReducer";
import Card from "../structure/Card";
import { error, success } from "../structure/Alert";
import { EventsAPI } from "../../api/index";

interface IKnownEventsScreenState {
  loading: boolean;
  events: IKnownEvent[];
  currentEvent: IKnownEvent;
  platform: string;
  newEvent: boolean;
  icons: string[];
  showDeleteModal: boolean;
}

interface IKnownEventsScreenProps {
  appUsersDevicesState: any;
  userState: any;
  appState: any;
}

interface IKnownEvent {
  defaultIcon: string;
  defaultMessage: string;
  defaultPersistent: boolean;
  domain: string;
  duplicateWindowSeconds: number;
  id: number;
  needsDevice: boolean;
  needsPet: boolean;
  needsPetProfileImage: boolean;
  shouldNotify: boolean;
}

const blankEvent: IKnownEvent = {
  defaultIcon: "",
  defaultMessage: "",
  defaultPersistent: false,
  domain: "",
  duplicateWindowSeconds: 120,
  id: 0,
  needsDevice: false,
  needsPet: false,
  needsPetProfileImage: false,
  shouldNotify: false,
};

class KnownEventsScreen extends React.Component<IKnownEventsScreenProps, IKnownEventsScreenState> {

  constructor(props: IKnownEventsScreenProps){
    super(props);
    this.state = {
      loading: false,
      events: [],
      icons: [],
      currentEvent: blankEvent,
      platform: "wagz2",
      newEvent: false,
      showDeleteModal: false
    };

    this.updateField = this.updateField.bind(this);
    this.updateEventField = this.updateEventField.bind(this);
    this.send = this.send.bind(this);
    this.fetchKnownEvents = this.fetchKnownEvents.bind(this);
    this.createNewEvent = this.createNewEvent.bind(this);
    this.toggleDeleteModal = this.toggleDeleteModal.bind(this);
    this.deleteKnownEvent = this.deleteKnownEvent.bind(this);
  }

  public componentDidMount(){
    this.fetchKnownEvents();
  }

  public render(){
    let loading = this.state.loading;
    if(!this.props.appUsersDevicesState[this.props.appState.app]){
      loading = true;
    }
    return (
      <div className="row">
        <div className="col-md-4">
          <Card title="Select Event" loading={loading}>
            <div className="form-group">
              <p><strong>Select a platform and event, or choose to add a new event</strong></p>
            </div>
            <div className="form-group">
              <label>Platform</label>
              <select className="form-control" id="platform" value={this.state.platform} onChange={this.updateField}>
                <option value="wagz2">Wagz</option>
                <option value="bd">Black + Decker</option>
                <option value="petzi" disabled={true}>Petzi (Coming soon!)</option>
              </select>
            </div>
            <div className="form-group">
              <label>Events</label>
              <select className="form-control" id="selectedEvent" onChange={this.updateField} value={this.state.currentEvent.id}>
                <option key={0} value={0}>SELECT AN EVENT</option>
                {this.state.events.map((event: any) => {
                  return (<option key={event.id} value={event.id}>{event.domain}</option>);
                })}
              </select>
            </div>
            <div className="form-group">
              <button className="btn btn-block btn-primary" onClick={this.createNewEvent}>Create New Event</button>
            </div>
          </Card>
        </div>

        <div className="col-md-4">
          <Card title="Manage Event" loading={loading}>
            <div className="form-group">
              <label>Event Domain</label>
              <p className="small">This is the unique key for the event</p>
              <input type="text" id="domain" className="form-control" value={this.state.currentEvent.domain} onChange={this.updateEventField} disabled={this.state.currentEvent.id !== 0}/>
            </div>
            <div className="form-group">
              <label>Default Icon</label>
              <select id="defaultIcon" className="form-control" value={this.state.currentEvent.defaultIcon} onChange={this.updateEventField}>
                {this.state.icons.map((icon: string) => {
                  return (<option key={icon} value={icon}>{icon}</option>);
                })}
              </select>
            </div>
            <div className="form-group">
              <label>Default Message</label>
              <p className="small">This is the default message. See to the right for possible place holders.</p>
              <textarea id="defaultMessage" className="form-control" value={this.state.currentEvent.defaultMessage} onChange={this.updateEventField} rows={3} />
            </div>
            <div className="form-group">
              <label>Duplicate Window Safety</label>
              <p className="small">This is the number of seconds between the event being considered a new one. For example, if an event has a duplicate window of 120, if two events are received by the server within 120 seconds of each other, the latest is ignored.</p>
              <input type="number" id="duplicateWindowSeconds" className="form-control" value={this.state.currentEvent.duplicateWindowSeconds} onChange={this.updateEventField} />
            </div>
            <div className="form-group">
              <label>Needs Pet</label>
              <p className="small">This event assumes a pet is needed for the placeholders.</p>
              <select id="needsPet" className="form-control" value={this.state.currentEvent.needsPet+""} onChange={this.updateEventField}>
                <option value={"true"}>True</option>
                <option value={"false"}>False</option>
              </select>
            </div>
            <div className="form-group">
              <label>Needs Pet Profile Image</label>
              <p className="small">This event assumes a pet is needed and will attempt to use a profile image.</p>
              <select id="needsPetProfileImage" className="form-control" value={this.state.currentEvent.needsPetProfileImage+""} onChange={this.updateEventField}>
                <option value={"true"}>True</option>
                <option value={"false"}>False</option>
              </select>
            </div>
            <div className="form-group">
              <label>Needs Device</label>
              <p className="small">This event assumes a device is needed for the placeholders.</p>
              <select id="needsDevice" className="form-control" value={this.state.currentEvent.needsDevice+""} onChange={this.updateEventField}>
                <option value={"true"}>True</option>
                <option value={"false"}>False</option>
              </select>
            </div>
            <div className="form-group">
              <label>Should Notify</label>
              <p className="small">Should a push notification be generated for this event?</p>
              <select id="shouldNotify" className="form-control" value={this.state.currentEvent.shouldNotify+""} onChange={this.updateEventField}>
                <option value={"true"}>True</option>
                <option value={"false"}>False</option>
              </select>
            </div>
            <div className="form-group">
              <button className="btn btn-block btn-success" onClick={this.send}>Save Known Event</button>
            </div>
            {this.state.currentEvent.id === 0 ? null : (
              <div className="form-group">
                <button className="btn btn-block btn-danger" onClick={this.toggleDeleteModal}>Delete Known Event</button>
              </div>
            )}
          </Card>
        </div>
        <div className="col-md-4">
          <Card title="Info" loading={loading}>
            <div className="form-group">
              <p><strong>Below is a list if icons and potential place holders for the message</strong></p>
            </div>
            <div className="form-group">
              <strong>Placeholders for Pets</strong>
              <ul>
                <li>{"\u007bpetName\u007d"}</li>
                <li>{"\u007bgenderPossessive\u007d"}</li>
              </ul>
              <strong>Placeholders for Devices</strong>
              <ul>
                <li>{"\u007bdeviceName\u007d"}</li>
              </ul>
            </div>
          </Card>
        </div>

        <Modal show={this.state.showDeleteModal} onHide={this.toggleDeleteModal}>
          <Modal.Header closeButton={true}>
            <Modal.Title>Delete Event</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="form-group">
              <p><strong>Are you absolutely sure you want to delete this known event? This cannot be undone and can cause serious problems if you do it to events actively
                being used.</strong></p>
              <p><strong>If you do this, you cannot blame engineering for bugs or missing data.</strong></p>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-danger" onClick={this.deleteKnownEvent}>Yes, Delete The Known Event</button>
            <button className="btn btn-success" onClick={this.toggleDeleteModal}>Nevermind</button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }


  private async updateField(e: any) {
    const ns: any = this.state;
    ns[e.target.id] = e.target.value;
    if(e.target.id === "platform"){
      // reload, but are platforms even needed here?
    } else if(e.target.id === "selectedEvent"){
      // populate some additional fields
      let foundEvent: IKnownEvent = blankEvent;
      for(const event of this.state.events){
        if(event.id === parseInt(e.target.value, 10)){
          foundEvent = event;
        }
      }
      if(foundEvent.id !== 0){
        ns.currentEvent = foundEvent;
        ns.newEvent = false;
      } else {
        ns.currentEvent = blankEvent;
        ns.newEvent = true;
      }
    }
    this.setState(ns);
  }

  private updateEventField(e: any) {
    const currentEvent: IKnownEvent = this.state.currentEvent;
    // parse it; since booleans aren't valid for selects, and numbers turn into strings, parse
    const field = e.target.id;
    let value = e.target.value;
    if(field === "duplicateWindowSeconds"){
      value = parseInt(value, 10);
    } else if (field === "defaultPersistent" || field === "needsDevice" || field === "needsPet" || field === "shouldNotify" || field === "needsPetProfileImage"){
      value = value === "true" ? true : false;
    }
    currentEvent[field] = value;
    this.setState({currentEvent});
  }

  private async send(){
    if(this.state.currentEvent.defaultMessage === "" || this.state.currentEvent.domain === ""){
      return error("Domain and default message cannot be blank");
    }
    this.setState({
      loading: true
    }, async () => {
      try{
        // now, is it an update or a create?
        if(this.state.currentEvent.id === 0){
          // create
          const res = await EventsAPI.createKnownEvent(this.state.platform, this.state.currentEvent);
          this.state.currentEvent.id = res.body.data.id;
        } else {
          // update
          await EventsAPI.updateKnownEvent(this.state.platform, this.state.currentEvent.domain, this.state.currentEvent);
        }
        success("Event saved!");
        return this.fetchKnownEvents();
      }catch(err){
        return this.setState({
          loading: false
        }, () => {
          error("We could not save that event");
        });
      }
    });
  }

  private createNewEvent(){
    this.setState({
      newEvent: true,
      currentEvent: blankEvent
    });
  }

  private async fetchKnownEvents(){
    this.setState({loading: true}, async () => {
      try{
        const eventRes = await EventsAPI.getKnownEvents(this.state.platform);
        // sort them
        const newEvents = eventRes.body.data.sort((a: any, b: any) => {
          return a.domain > b.domain ? 1 : -1;
        });
        const iconsRes = await EventsAPI.getEventIcons(this.state.platform);
        const currentEvent = this.state.currentEvent;
        if(this.state.currentEvent.id === 0){
          currentEvent.defaultIcon = iconsRes.body.data[0];
        }
        this.setState({
          events: newEvents,
          icons: iconsRes.body.data,
          loading: false
        });
      }catch(err){
        this.setState({loading: false});
        return error("Could not fetch known events");
      }
    });
  }

  private toggleDeleteModal(){
    this.setState({
      showDeleteModal: !this.state.showDeleteModal
    });
  }

  private async deleteKnownEvent(){
    this.setState({
      loading: true,
      showDeleteModal: false
    }, async () => {
      try{
        await EventsAPI.deleteKnownEvent(this.state.platform, this.state.currentEvent.domain, {});
        return this.setState({
          currentEvent: blankEvent
        }, async () => {
          this.fetchKnownEvents();
          return success("Known event deleted!");
        });
      }catch(err){
        this.setState({
          loading: false
        }, () => {
          return error("Could not delete that known event. Please contact engineering");
        });
      }
    });
  }

}

const mapStateToProps = function map(s: any) {
  return {
    appState: s.appState,
    appUsersDevicesState: s.appUsersDevicesState
  };
};

function mapDispatchToProps(dispatch: any) {
  return {
    actions: bindActionCreators(AppActions, dispatch),
  };
}

export default withRouter(connect<{}, {}, any>(mapStateToProps, mapDispatchToProps)(KnownEventsScreen));


// WEBPACK FOOTER //
// ./src/components/Events/Events.tsx